import { IAppState, ITeamData } from '../types/state.d';
import {
  apiActionTypes,
  appActionTypes,
} from '../actions/actionCreators/actionTypes';

import { AnyAction } from 'redux';

type State = IAppState['api'];

export const isShortNameValid = (
  state: State['isShortNameValid'] = null,
  // eslint-disable-next-line no-shadow
  { type, isShortNameValid: actionIsShortNameValid }: AnyAction,
): State['isShortNameValid'] => {
  switch (type) {
    case apiActionTypes.IS_SHORT_NAME_VALID:
      return actionIsShortNameValid;
    case apiActionTypes.CLEAR_SHORT_NAME_VALIDITY:
      return null;
    default:
      return state;
  }
};

export const GDPRConsents = (
  state: State['GDPRConsents'] = null,
  // eslint-disable-next-line no-shadow
  { type, GDPRConsents }: AnyAction,
): State['GDPRConsents'] => {
  switch (type) {
    case apiActionTypes.SAVE_GDPR_CONSENTS:
      return GDPRConsents;
    default:
      return state;
  }
};

export const errorStatus = (
  state: State['errorStatus'] = null,
  // eslint-disable-next-line no-shadow
  { type, errorStatus }: AnyAction,
): State['errorStatus'] => {
  switch (type) {
    case apiActionTypes.TEAM_REQUEST_ERROR:
    case apiActionTypes.SET_ERROR_STATUS:
      return errorStatus;
    default:
      return state;
  }
};

export const teamData = (
  state: State['teamData'] = null,
  {
    type,
    data,
    heroImage,
    teamName,
    teamData: actionTeamData,
    teamGuid: actionTeamGuid,
    membershipPolicy,
    numberOfMembers,
  }: // eslint-disable-next-line no-shadow
  AnyAction,
): State['teamData'] => {
  switch (type) {
    case appActionTypes.SAVE_STORY_DATA:
      return {
        ...(state as ITeamData),
        story: data.story,
      };
    case apiActionTypes.SAVE_TEAM_NAME:
      return {
        ...(state as ITeamData),
        name: teamName,
      };
    case apiActionTypes.SAVE_UPLOADED_COVER_PHOTO:
      return {
        ...(state as ITeamData),
        coverPhotoImageId: heroImage,
      };
    case appActionTypes.SAVE_TEAM_SETTINGS_DATA:
      return {
        ...(state as ITeamData),
        shortName: data.shortName,
        fundraisingConfiguration: {
          ...(state as ITeamData).fundraisingConfiguration,
          targetAmount: data.teamFundraisingTarget,
        },
      };
    case apiActionTypes.TEAM_REQUEST_SUCCESS:
      return { ...state, ...actionTeamData };
    case appActionTypes.SAVE_TEAM_GUID:
      return {
        ...(state as ITeamData),
        teamGuid: actionTeamGuid,
      };
    case apiActionTypes.SAVE_MEMBERSHIP_POLICY:
      return {
        ...(state as ITeamData),
        membershipPolicy,
      };
    case apiActionTypes.SUBMIT_TEAM_DATA_REQUEST_SUCCESS:
      return {
        ...(state as ITeamData),
        name: data.teamName,
        story: data.story,
        coverPhotoImageId: data.heroImage,
        fundraisingConfiguration: {
          ...(state as ITeamData).fundraisingConfiguration,
          targetAmount: data.fundraisingTarget,
        },
      };
    case apiActionTypes.UPDATE_NUMBER_OF_MEMBERS:
      return {
        ...(state as ITeamData),
        membership: {
          ...(state as ITeamData).membership,
          numberOfMembers,
        },
      };
    default:
      return state;
  }
};

export const eventData = (
  state: State['eventData'] = null,
  action: AnyAction,
): State['eventData'] => {
  switch (action.type) {
    case apiActionTypes.SAVE_EVENT_DETAILS:
    case apiActionTypes.GET_EVENT_REQUEST_SUCCESS:
      return action.data;
    default:
      return state;
  }
};

export const membersListData = (
  state: State['membersListData'] = {
    numberOfMembers: 0,
    members: [],
    pageInfo: { hasNextPage: false, hasPreviousPage: false },
  },
  action: AnyAction,
): State['membersListData'] => {
  switch (action.type) {
    case apiActionTypes.SAVE_MEMBERS_LIST_DATA:
      return action.data;
    default:
      return state;
  }
};

export const fundraisingPagesData = (
  state: State['fundraisingPagesData'] = [],
  action: AnyAction,
): State['fundraisingPagesData'] => {
  switch (action.type) {
    case apiActionTypes.SAVE_FUNDRAISING_PAGES:
    case apiActionTypes.GET_FUNDRAISING_PAGES_REQUEST_SUCCESS:
      return action.data;
    default:
      return state;
  }
};

export const frpData = (
  state: State['frpData'] = {},
  action: AnyAction,
): State['frpData'] => {
  switch (action.type) {
    case apiActionTypes.SAVE_FRP_DATA:
      return action.data;
    default:
      return state;
  }
};
